import React from 'react'
import { RegionOptionsStrings } from 'enums/RegionOptions'
import { ResolutionOptionsStrings } from 'enums/ResolutionOptions'

// @ts-ignore
import { Geo } from '@netbasequid/chart'
import { useDisplayTheme } from '../../../hooks/useUiState'
import { getDisplayModeOption, getRegionOption, getResolutionOption } from './utils'

type GeoChartProps = {
  data: (number | string)[][]
  region: RegionOptionsStrings
  resolution: ResolutionOptionsStrings
  unit?: string
  colorSetting?: string
  onReady?: (geoApi: Record<string, any>) => void
  onSelect?: (selection: any) => void
}

const GeoChart = ({
  data,
  region,
  resolution,
  unit,
  colorSetting,
  onReady,
  onSelect
}: GeoChartProps) => {
  const theme = useDisplayTheme()
  const mapsApiKey = process.env.REACT_APP_GOOGLE_MAP_KEY

  const geoRegion = getRegionOption(region)
  const geoResolution = getResolutionOption(resolution)
  const geoDisplayMode = getDisplayModeOption(resolution)

  return (
    <Geo
      mode={theme}
      mapsApiKey={mapsApiKey}
      height="100%"
      // below are from props
      data={data}
      region={geoRegion}
      resolution={geoResolution}
      displayMode={geoDisplayMode}
      unit={unit}
      colorSetting={colorSetting}
      onReady={onReady}
      onSelect={onSelect}
    />
  )
}

export default GeoChart
